package org.gstechnovos.jexonplastech.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.gstechnovos.jexonplastech.components.SocialBar
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.models.Theme
import org.gstechnovos.jexonplastech.styles.NavigationItemStyle
import org.gstechnovos.jexonplastech.util.Constants
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.gstechnovos.jexonplastech.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun FooterSection() {
    Box(
        modifier = Modifier.fillMaxWidth().backgroundColor(Theme.LighterGray.rgb).maxWidth(SECTION_WIDTH.px).padding(topBottom = 50.px),
        contentAlignment = Alignment.Center
    ) {
        FooterContent()
    }
}

@Composable
fun FooterContent() {
    val breakpoint = LocalBreakpoint.current

    Column(
        modifier = Modifier.fillMaxWidth(
                if (breakpoint >= Breakpoint.MD) 100.percent else 90.percent
            ), horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Image(
            modifier = Modifier.size(100.px), src = Res.Image.LOGO, description = "logo"
        )

        if (breakpoint > Breakpoint.SM) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Center
            ) {
                FooterMenu()
            }
        }else{
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                FooterMenu(row = false)
            }
        }

        SocialBar(row = true)
    }
}

@Composable
fun FooterMenu(row: Boolean = true) {
    Section.entries.take(6).forEach { section ->
        Link(
            modifier = NavigationItemStyle.toModifier()
                .fontSize(14.px)
                .padding(right = if (row) 20.px else 0.px,
                    bottom = if (row) 0.px else 20.px),
            path = section.path,
            text = section.title
        )

    }
}